import { Navigate, Route, Routes } from 'react-router-dom'
import { NucleoFamiliar, Search } from 'pages'

const RoutesApp = () => {
  return (
    <Routes>
      <Route path={process.env.PUBLIC_URL}>
        <Route path="pesquisa">
          <Route path=":type" element={<NucleoFamiliar />} />
          <Route index element={<Search />} />
        </Route>
        <Route
          index
          element={<Navigate to={`${process.env.PUBLIC_URL}/pesquisa`} />}
        />
      </Route>
      <Route path="*" element={<Navigate to={process.env.PUBLIC_URL} />} />
    </Routes>
  )
}

export default RoutesApp
